module.exports = __webpack_public_path__ + "img/eagleScrn2.7b6fad22.png";